export default __webpack_public_path__ + "static/media/glassware_dark.028149b0.png";